import React, { FC, useEffect, useRef } from 'react';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { useDispatch } from 'react-redux';
import { mainActions } from '$store/main';
import { InfoBlock } from '$uikit';
import { useTranslator } from '$hooks';
import { setOnlyPayPopUpShown } from '$utils';

export const OnlypaySheet: FC<{ url: string; provider?: string }> = ({
  url,
  provider = '',
}) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    setOnlyPayPopUpShown(true);

    const handleMessage = (event: MessageEvent) => {
      if (event.data === 'close_me') {
        dispatch(mainActions.setPopup(null));
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      setOnlyPayPopUpShown(false);
      window.removeEventListener('message', handleMessage);
    };
  }, [dispatch]);

  return (
    <BottomSheet title="Payment" className="PayConfirmSheet__wrapper">
      {provider === 'settlepayWise' && (
        <div style={{ padding: '0 12px 8px' }}>
          <InfoBlock type="warning">{t('top_up_sheet_delay_warning')}</InfoBlock>
        </div>
      )}
      <iframe
        allow="fullscreen; camera; microphone; geolocation; autoplay; encrypted-media; clipboard-write; display-capture"
        ref={iframeRef}
        src={url}
        className="PayConfirmSheet__iframe"
      />
    </BottomSheet>
  );
};
